let cachedBackgroundPromise: Promise<string | null> | null = null;

const PDF_BACKGROUND_URL = '/pdf/pdf_background.png';

const blobToDataUrl = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }
      reject(new Error('Falha ao converter o fundo do PDF.'));
    };
    reader.onerror = () => reject(new Error('Falha ao ler o fundo do PDF.'));
    reader.readAsDataURL(blob);
  });

export const getPdfBackgroundDataUrl = async (): Promise<string | null> => {
  if (!cachedBackgroundPromise) {
    cachedBackgroundPromise = fetch(PDF_BACKGROUND_URL)
      .then((response) => {
        if (!response.ok) {
          return null;
        }
        return response.blob();
      })
      .then((blob) => {
        if (!blob) {
          return null;
        }
        return blobToDataUrl(blob);
      })
      .catch(() => null);
  }

  return cachedBackgroundPromise;
};
